<template>
  <v-container
    fill-height
    :style="{ backgroundImage: 'url(' + bg + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"
  >
    <v-layout align-center justify-center>
      <v-flex md6>
        <v-card class="pa-5">
          <v-layout column>
            <h2>LEARN AND EARN</h2>
            <h1><span class="primary--text">CPD</span> POINTS</h1>
            <p>Be among the 1st <b class="accent--text">1000 to complete the course!</b> Learn from the world-class Filipino lecturers and earn units on the topics like <i class="purple--text">Iodine Nutrition, Management of Thyroid Disorders in Pregnancy, Hypothyroidism and more.</i></p>
          </v-layout>
          <v-layout justify-center>
            <v-flex md6 text-xs-center>
              <v-btn color="primary" @click="goto">Register for Full Access</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      bg: require('@/assets/bg/water_6.png')
    }
  },
  methods: {
    goto () {
      let container = document.getElementById('regFormContainer')
      window.scrollTo(0, container.offsetTop)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/home/slide2.vue